export const messages = {
  en: {
    shopCommunity: {
      queryCondition: 'Query Condition',
      shopName: 'Shop Name',
      communityName: 'Community Name',
      auditPass: 'Audit Pass',
      auditNotPass: 'Audit Not Pass',
      query: 'Query',
      shopCommunity: 'Shop Community',
      communityCode: 'Community Code',
      settledTime: 'Settled Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      state: 'State',
      operation: 'Operation',
      withdraw: 'Withdraw'
    },
    audit: {
      auditStatus: 'Audit Status',
      pleaseAudit: 'Please Audit',
      agree: 'Agree',
      reject: 'Reject',
      reason: 'Reason',
      reasonPlaceholder: 'Required, please fill in the reason',
      cancel: 'Cancel',
      submit: 'Submit',
      stateRequired: 'Audit status cannot be empty',
      remarkRequired: 'Reason content cannot be empty',
      remarkMaxLength: 'Reason content cannot exceed 200 characters',
      auditSuccess: 'Audit successful'
    },
    shopCommunityWithdraw: {
      confirmOperation: 'Please confirm your operation',
      withdrawReason: 'Withdraw Reason',
      remarkPlaceholder: 'Required, please fill in the withdraw reason',
      cancel: 'Cancel',
      confirmWithdraw: 'Confirm Withdraw',
      remarkRequired: 'Withdraw reason cannot be empty',
      processSuccess: 'Process successful',
      processFailed: 'Process failed: '
    }
  },
  zh: {
    shopCommunity: {
      queryCondition: '查询条件',
      shopName: '店铺名称',
      communityName: '小区名称',
      auditPass: '审核通过',
      auditNotPass: '审核不通过',
      query: '查询',
      shopCommunity: '小区商铺',
      communityCode: '小区编码',
      settledTime: '入驻时间',
      startTime: '开始时间',
      endTime: '结束时间',
      state: '状态',
      operation: '操作',
      withdraw: '撤回'
    },
    audit: {
      auditStatus: '审核状态',
      pleaseAudit: '请审核',
      agree: '同意',
      reject: '拒绝',
      reason: '原因',
      reasonPlaceholder: '必填，请填写原因',
      cancel: '取消',
      submit: '提交',
      stateRequired: '审核状态不能为空',
      remarkRequired: '原因内容不能为空',
      remarkMaxLength: '原因内容不能超过200',
      auditSuccess: '审核成功'
    },
    shopCommunityWithdraw: {
      confirmOperation: '请确认您的操作',
      withdrawReason: '撤回说明',
      remarkPlaceholder: '必填，请填写撤回意见',
      cancel: '点错了',
      confirmWithdraw: '确认撤回',
      remarkRequired: '撤回说明不能为空',
      processSuccess: '处理成功',
      processFailed: '处理失败：'
    }
  }
}